import { combineReducers } from 'redux';
import authReducer from './authReducer';
import globalReducer from './globalReducer';
import notificationReducer from './notificationReducer';
import searchBarReducer from './searchBarReducer';
import sideBarReducer from './sideBarReducer';
import tablesQuickAccessReducer from './TablesQuickAccessReducer';
import themeReducer from './themeReducer';
import cropReducer from './cropReducer';

const reducers = combineReducers({
	auth: authReducer,
	global: globalReducer,
	theme: themeReducer,
	sidebar: sideBarReducer,
	searchbar: searchBarReducer,
	tablesQuickAccess: tablesQuickAccessReducer,
	notification: notificationReducer,
	crop: cropReducer
});

export default reducers;
export type RootState = ReturnType<typeof reducers>;
